import {
  handleWithErrorMessage,
  handleWithMessageAndLoading,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/microsites";
import {
  SET_IS_FETCHING_MICROSITES,
  SET_IS_FETCHING_MICROSITE,
  SET_IS_EDITING_MICROSITE,
  SET_MICROSITES,
  SET_CURRENT_MICROSITE,
  SET_CURRENT_PAGES
} from "@/store/modules/microsites/mutations";
import { forEach } from "lodash";

export const FETCH_MICROSITES = "FETCH_MICROSITES";
export const ADD_MICROSITE = "ADD_MICROSITE";
export const FETCH_MICROSITE = "FETCH_MICROSITE";
export const EDIT_MICROSITE = "EDIT_MICROSITE";
export const ADD_MICROSITE_PAGE = "ADD_MICROSITE_PAGE";
export const EDIT_MICROSITE_PAGE = "EDIT_MICROSITE_PAGE";
export const DELETE_MICROSITE_PAGE = "DELETE_MICROSITE_PAGE";
export const UPDATE_PAGE_ORDER = "UPDATE_PAGE_ORDER";

const actions = {
  async [FETCH_MICROSITES]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_MICROSITES, isLoading),
      setDataFunction: ({ data }) => commit(SET_MICROSITES, data)
    });
  },
  async [FETCH_MICROSITE]({ dispatch, commit }, id) {
    commit(SET_IS_FETCHING_MICROSITE, true);
    await handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getCurrentMicrosite(id),
      setDataFunction: ({ data }) => commit(SET_CURRENT_MICROSITE, data)
    });
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getCurrentMicrositePages(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_MICROSITE, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_PAGES, data)
    });
  },
  async [ADD_MICROSITE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).add(data), dispatch);
    dispatch(FETCH_MICROSITES, {});
  },
  async [EDIT_MICROSITE]({ commit, dispatch }, data) {
    return handleWithMessageAndLoading({
      dispatch,
      request: () => api(commit).edit(data),
      setLoadingFunction: isLoading =>
        commit(SET_IS_EDITING_MICROSITE, isLoading),
      setDataFunction: data => commit(SET_CURRENT_MICROSITE, data)
    });
  },
  async [ADD_MICROSITE_PAGE]({ commit, dispatch }, data) {
    const { data: createdPage } = await handleWithErrorMessage({
      request: () => api(commit).addPage(data),
      dispatch
    });
    const { micrositeId } = createdPage;
    dispatch(FETCH_MICROSITE, micrositeId);
  },
  async [EDIT_MICROSITE_PAGE]({ commit, dispatch }, data) {
    const { data: udpatedPage } = await handleWithErrorMessage({
      request: () => api(commit).editPage(data),
      dispatch
    });
    const { micrositeId } = udpatedPage;
    dispatch(FETCH_MICROSITE, micrositeId);
  },
  async [DELETE_MICROSITE_PAGE]({ commit, dispatch }, { micrositeId, id }) {
    await handleWithErrorMessage({
      request: () => api(commit).deletePage(id),
      dispatch
    });
    dispatch(FETCH_MICROSITE, micrositeId);
  },
  async [UPDATE_PAGE_ORDER]({ commit, dispatch }, pages) {
    commit(SET_CURRENT_PAGES, pages);
    forEach(pages, async (page, displayOrder) => {
      await handleWithErrorMessage({
        request: () => api(commit).editPage({ displayOrder, ...page }),
        dispatch
      });
    });
  }
};

export default actions;
